import { DashboardResponse } from '../../models/login';
import {
  AnalyticsError,
  AnalyticsPage,
  AnalyticsProfile,
  AnalyticsSiteAssets,
  AnalyticsUser,
  ClickEventAnalytics,
  ModalLoadLoginAnalytics,
  PageLoadAnalytics,
  PageLoadErrorAnalytics,
  PageLoadLoginAnalytics
} from '../../models/utils/analytics.interfaces';
import { dashboardErrorMocks } from '../login';

export const adobePageAnalyticsMocks: AnalyticsPage = {
  info: {
    page_name: 'homepage',
    page_url: '/',
    page_type: 'homepage',
    previous_page_name: '',
    previous_page_url: '',
    section: '',
    sub_section: 'no-subsection',
    country: 'US',
    language: 'en',
    sys_env: 'responsive',
    legacy_page_name: 'dal:homepage',
    page_load_time: '1'
  }
};

export const adobeModalAnalyticsMocks: AnalyticsPage = {
  info: {
    legacy_page_name: 'Home Page',
    page_name: 'dal:homepage',
    subpage_name: '',
    section: 'home',
    sub_section: 'no-subsection',
    country: 'us',
    language: 'en',
    sys_env: 'responsive'
  }
};

export const adobeProfileAnalyticsMocks: AnalyticsProfile = {
  skymiles_number: '23476762474',
  medalion_tier: 'GM',
  cobrand_type: 'Gold',
  available_miles: 67890000,
  email: 'test123@gmail.com',
  company_name: ''
};

export const adobeUserAnalyticsMocks: AnalyticsUser = {
  attributes: {
    is_logged_in: 'unauthenticated'
  }
};

export const adobeUserLoggedInAnalyticsMocks: AnalyticsUser = {
  attributes: {
    is_logged_in: 'authenticated',
    login_method: 'user name',
    login_state: 'hot'
  },
  profile: adobeProfileAnalyticsMocks
};

export const adobeErrorAnalyticsMocks: AnalyticsError = {
  type: 'home page load error',
  code: '01024',
  message: `sorry, we’re currently unable to display your content`
};

export const adobeSiteAssetsAnalyticsMocks: AnalyticsSiteAssets[] = [
  {
    type: 'banner',
    position: '1',
    name: 'fast free wifi and so much more',
    value: '896.5',
    miles: '11,900',
    fare_type: 'money',
    currency_code: 'usd',
    source: 'page content'
  },
  {
    type: 'hero',
    position: '1',
    name: 'HOW CAN I CANCEL/CHANGE MY FLIGHT?',
    source: 'page content'
  },
  {
    type: 'tile',
    position: '1',
    name: 'OUR ONBOARD EXPERIENCE',
    source: 'page content'
  },
  {
    type: 'tile',
    position: '2',
    name: 'READY FOR ADVENTURE?',
    source: 'page content'
  },
  {
    type: 'tile',
    position: '3',
    name: 'TREAT YOURSELF TO PREMIUM TRAVEL',
    source: 'page content'
  },
  {
    type: 'hero',
    position: '2',
    name: 'EXPLORE DESTINATIONS & TRAVEL REQUIREMENTS',
    source: 'page content'
  },
  {
    type: 'hero',
    position: '3',
    name: 'EVERYTHING YOU NEED, ALL IN ONE PLACE',
    source: 'page content'
  },
  {
    type: 'hero',
    position: '4',
    name: 'BUY $300 IN DELTA GIFT CARDS, GET A $20 BONUS',
    source: 'page content'
  }
];

export const adobePageLoadAnalyticsMocks: PageLoadAnalytics = {
  event_detail: 'homepage',
  event: 'page-load',
  page: adobePageAnalyticsMocks,
  user: adobeUserLoggedInAnalyticsMocks,
  site_assets: adobeSiteAssetsAnalyticsMocks
};
export const adobePageLoadLoginAnalyticsMocks: PageLoadLoginAnalytics = {
  event_detail: 'login page',
  event: 'page load',
  page: adobePageAnalyticsMocks,
  user: adobeUserLoggedInAnalyticsMocks
};

export const adobeModalLoadLoginAnalyticsMocks: ModalLoadLoginAnalytics = {
  event_detail: 'login page',
  event: 'modal load',
  page: adobeModalAnalyticsMocks
};

export const adobeClickEventAnalyticsMocks: ClickEventAnalytics = {
  event_detail: '',
  event: 'click',
  click: {
    name: '',
    type: 'button',
    page_section: 'test-section',
    action: ''
  },
  user: adobeUserAnalyticsMocks,
  search: {
    term: '',
    type: ''
  }
};

export const adobePageLoadErrorAnalyticsMocks: PageLoadErrorAnalytics = {
  event_detail: 'homepage',
  event: 'page-load',
  page: adobePageAnalyticsMocks,
  user: adobeUserAnalyticsMocks,
  error: adobeErrorAnalyticsMocks
};

export const dashboardMockResponse: DashboardResponse = {
  smNumber: '8006270311',
  firstName: 'Coco',
  lastName: 'Olive',
  smBalance: '820',
  membershipLevel: 'DM',
  enrollmentDate: '2014-05-27',
  prefix: 'Mr',
  primaryEmailAddress: 'test@example.com',
  preferredName: 'FR',
  cobrandCardtypeList: 'AXCV',
  isAbove18: true,
  medallionMemberDesc: 'Diamond Medallion',
  medallionMbrInd: '1',
  country: 'US',
  language: 'EN',
  customerID: '0008006270311',
  MQMBalance: '50000',
  loyaltyPromoInd: 'Y',
  loyaltyPromoLink: '/mypromos/displayPromotions',
  sysDrvdPrefHomeArptCd: 'MSP',
  usrProvdPrefHomeArptCd: 'JFK',
  crprtAgrmntId: '7814792|3000000008072|US123456789',
  crprtAgrmntTypeCode: 'CNA|CNA|SME',
  crprtPricingDiscCode: '579EQ00|4BW0F00| ',
  crprtName: '2CHECKOUT|GOOGLE|TAI',
  adminCompanyName: 'NA|NA|NA',
  smeCompanyName: 'tai',
  smeCardTypes: 'PLATINUM',
  skyPriority: true,
  pwmMbr: false,
  crprtAgrmntFound: true,
  skymilesMember: true,
  langPromptIndicator: false,
  rememberMeIndicator: false,
  millionMiler: false,
  irop: false,
  spgInd: false,
  firstTime: true,
  hasUserNm: false,
  is360Tier: false,
  promoCdInd: false,
  loggedIn: true,
  isWarmState: false,
  hasSQA: true,
  hasEmail: true,
  hasTripLink: 'N',
  hasNuTvl: 'N',
  hasPhone: true,
  permType: 'NA|NA|NA',
  pgmType: 'NA|NA|NA',
  accessToken: 'NA|NA|NA',
  userId: 'NA|NA|NA',
  program: 'NONE|CSA|SKYB',
  contractMgtEnt: 'NA|NAM|NA',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  formNameSubmitted: '',
  isEmailValid: true,
  middleName: '',
  milesExpireDate: '',
  millionMilerTier: '',
  nameSuffix: '',
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeLastName: '',
  spid: '',
  triplinkErrorCd: '',
  userNameType: '',
  venderID: '',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  errors: [dashboardErrorMocks],
  emailAddressLocalDate: '2024-04-18'
  // cobrandCardtypeAffiliationIdList: '',
  // cobrandCardtypeDescList: '',
  // cobrandCardtypeSkyclubEligibleList: ''
};

export const nullResponse: DashboardResponse = {
  primaryEmailAddress: '',
  smNumber: '',
  membershipLevel: '',
  smeCardTypes: '',
  smBalance: '',
  MQMBalance: '',
  accessToken: '',
  adminCompanyName: '',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  contractMgtEnt: '',
  country: '',
  crprtAgrmntFound: false,
  crprtAgrmntId: '',
  crprtAgrmntTypeCode: '',
  crprtName: '',
  crprtPricingDiscCode: '',
  customerID: '',
  cobrandCardtypeList: '',
  enrollmentDate: '',
  errors: [],
  firstName: '',
  firstTime: false,
  formNameSubmitted: '',
  hasEmail: false,
  hasNuTvl: '',
  hasSQA: false,
  hasTripLink: '',
  hasUserNm: false,
  hasPhone: false,
  irop: false,
  is360Tier: false,
  isAbove18: false,
  isEmailValid: false,
  isWarmState: false,
  langPromptIndicator: false,
  language: '',
  lastName: '',
  loggedIn: false,
  loyaltyPromoInd: '',
  loyaltyPromoLink: '',
  medallionMbrInd: '',
  medallionMemberDesc: '',
  middleName: '',
  milesExpireDate: '',
  millionMiler: false,
  millionMilerTier: '',
  nameSuffix: '',
  permType: '',
  pgmType: '',
  preferredName: '',
  prefix: '',
  program: '',
  promoCdInd: false,
  pwmMbr: false,
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeIndicator: false,
  rememberMeLastName: '',
  skyPriority: false,
  skymilesMember: false,
  smeCompanyName: '',
  spgInd: false,
  spid: '',
  sysDrvdPrefHomeArptCd: '',
  triplinkErrorCd: '',
  userId: '',
  userNameType: '',
  usrProvdPrefHomeArptCd: '',
  venderID: '',
  isSkyClubMember: '',
  emailAddressLocalDate: ''
};
